module.exports = __webpack_public_path__ + "static/media/Real Estate Dimensions Block.c3706151.svg";